import { Briefcase, Plus } from 'lucide-react'

interface WorkEmptyStateProps {
  onCreateNew: () => void
}

export default function WorkEmptyState({ onCreateNew }: WorkEmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        gap: '16px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: '64px',
          height: '64px',
          borderRadius: '16px',
          background: 'rgba(99, 102, 241, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Briefcase size={28} style={{ color: 'var(--primary, #6366f1)' }} />
      </div>
      <div>
        <div style={{ fontSize: '16px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px' }}>
          No jobs yet
        </div>
        <div style={{ fontSize: '13px', color: 'var(--text-muted, #6b7280)', maxWidth: '280px' }}>
          Submit your first AI job — transcription, image generation, content writing, and more.
        </div>
      </div>
      <button
        onClick={onCreateNew}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '10px 20px',
          borderRadius: '10px',
          background: 'var(--primary, #6366f1)',
          color: '#fff',
          border: 'none',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        <Plus size={16} />
        Create First Job
      </button>
    </div>
  )
}
